import { combineReducers } from "redux";

import preferenceReducer from "./preference/reducer";
import userReducer from "./user/reducer";
import modalReducer from "./modal/reducer";
import sheetReducer from "./sheet/reducer";
import productReducer from "./product/reducer";
import postReducer from "./post/reducer";
import indicatorReducer from "./indicator/reducer";
import authReducer from "./auth/reducer";
import sidebarReducer from "./sidebar/reducer";
import notificationReducer from "./notification/reducer";
import brandReducer from "./brand/reducer";
import popupReducer from "./popup/reducer";
import settingsReducer from "./settings/reducer";
import campaignReducer from "./campaign/reducer";
import pathCachesReducer from "./pathCaches/reducer"
import instagramReducer from './instagram/reducer'
import appealReelsReducer from './appealReels/reducer'

const rootReducer = combineReducers({
  preferences: preferenceReducer,
  user: userReducer,
  modal: modalReducer,
  sheet: sheetReducer,
  popup: popupReducer,
  campaign: campaignReducer,
  product: productReducer,
  post: postReducer,
  indicator: indicatorReducer,
  auth: authReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,
  brand: brandReducer,
  settings: settingsReducer,
  pathCaches: pathCachesReducer,
  instagram: instagramReducer,
  appealReels: appealReelsReducer
});

export default rootReducer;
